import { extendTheme } from '@chakra-ui/react';
import { theme as baseTheme } from '@saas-ui-pro/react';

import { components } from './components';
import { colors } from './foundations/colors';
import semanticTokens from './foundations/semantic-tokens';

export const theme = extendTheme(baseTheme, {
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  colors,
  semanticTokens,
  textStyles: {
    headingHero: {
      fontSize: ['24px', '36px'],
      fontWeight: 600,
      lineHeight: ['28px', '40px'],
      letterSpacing: 0,
    },
    headingPrimary: {
      fontSize: ['20px', '24px'],
      fontWeight: 600,
      lineHeight: ['24px', '32px'],
      letterSpacing: 0,
    },
    headingSecondary: {
      fontSize: ['18px', '20px'],
      fontWeight: 600,
      lineHeight: ['20px', '28px'],
      letterSpacing: 0,
    },
    base: {
      heroRegular: {
        fontSize: ['14px', '18px'],
        fontWeight: 400,
        lineHeight: ['20px', '24px'],
        letterSpacing: 0,
      },
      heroSemiBold: {
        fontSize: ['14px', '18px'],
        fontWeight: 600,
        lineHeight: ['20px', '24px'],
        letterSpacing: 0,
      },
      primaryRegular: {
        fontSize: ['14px', '16px'],
        fontWeight: 400,
        lineHeight: ['20px', '20px'],
        letterSpacing: 0,
      },
      primarySemiBold: {
        fontSize: ['14px', '16px'],
        fontWeight: 600,
        lineHeight: ['20px', '20px'],
        letterSpacing: 0,
      },
      secondaryRegular: {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '24px',
        letterSpacing: 0,
      },
      secondarySemiBold: {
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '24px',
        letterSpacing: 0,
      },
    },
    note: {
      primaryRegular: {
        fontSize: '13px',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: 0,
      },
      primarySemiBold: {
        fontSize: '13px',
        fontWeight: 600,
        lineHeight: '20px',
        letterSpacing: 0,
      },
    },
    tag: {
      primary: {
        fontSize: '13px',
        fontWeight: 600,
        lineHeight: '20px',
        letterSpacing: 0,
        textTransform: 'uppercase',
      },
    },
  },
  components,
  breakpoints: {
    base: '0em',
    sm: '25em',
    md: '48em',
    lg: '62em',
    xl: '80em',
    '2xl': '96em',
    '3xl': '120em',
  },
});

export default theme;
